import React from 'react';
import styled from 'styled-components';
import { LiquidGlassCard } from './LiquidGlass/index';
import { useResponsiveLayout, LAYOUT_CONFIG } from '../config/componentLayout';

/*
  DWEB-180 — `scroll-margin-top: 120px` was here and did nothing.

  It is the right idea in the wrong place twice over. The site's nav scrolls
  through react-scroll, which does JS arithmetic and never consults CSS, so
  this was inert on the one path that matters; and for the paths that DO
  consult CSS it duplicates `scroll-padding-top` on html (index.css), which
  covers every target rather than only the ones wrapped in a PageContainer —
  form fields included. Keeping both would make native scrolling overshoot by
  a full header, since container padding and target margin ADD.

  So the container-level declaration is the one that stays, and 120px goes.
  It was also a fourth value for a thing that has one: the header is 70/95.6.
*/
const PageContainer = styled.div`
  position: relative;
  padding: ${props => props.padding};
  margin-bottom: ${props => props.marginBottom};
`;

const ContentContainer = styled(LiquidGlassCard)`
  max-width: ${props => props.maxWidth || LAYOUT_CONFIG.container.maxWidth.desktop};
  margin: ${LAYOUT_CONFIG.container.margin};
`;

const DynamicPageWrapper = ({
  id,
  componentName,
  backgroundKey,
  children,
  containerProps = {},
  contentProps = {},
  density = 'normal' // compact, normal, comfortable
}) => {
  const layout = useResponsiveLayout(componentName);

  // Apply density-aware spacing if requested
  const spacingConfig = density !== 'normal' ? layout.getDensitySpacing(density) : {
    padding: layout.padding,
    titleMargin: layout.titleMargin,
    paragraphMargin: layout.paragraphMargin
  };

  return (
    <PageContainer
      id={id}
      padding={spacingConfig.padding}
      marginBottom={layout.marginBottom}
      {...containerProps}
    >
      <ContentContainer
        variant="auto"
        maxWidth={layout.maxWidth}
        style={{
          background: 'transparent',
          backdropFilter: 'none',
          WebkitBackdropFilter: 'none',
          border: 'none',
          boxShadow: 'none',
          ...contentProps.style
        }}
        {...contentProps}
      >
        {children}
      </ContentContainer>
    </PageContainer>
  );
};

export default DynamicPageWrapper;
